import script from "./ElementBasicLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./ElementBasicLayout.vue?vue&type=script&setup=true&lang=ts"

import "./ElementBasicLayout.vue?vue&type=style&index=0&id=92f8effa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92f8effa"]])

export default __exports__